/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Pricedrops1Inputs */

const he_nav_pricedrops1 = /** @type {(inputs: Nav_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידות מחירים חדשות`)
};

const en_nav_pricedrops1 = /** @type {(inputs: Nav_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Price Drops`)
};

/**
* | output |
* | --- |
* | "Recent Price Drops" |
*
* @param {Nav_Pricedrops1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const nav_pricedrops1 = /** @type {((inputs?: Nav_Pricedrops1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Pricedrops1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_pricedrops1(inputs)
	return en_nav_pricedrops1(inputs)
});
export { nav_pricedrops1 as "nav_priceDrops" }